/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/to_counter.json`.

import type { DefinitionDocs } from '../../definition_types';

const docs: DefinitionDocs = {
  description: 'Converts a numeric value to its counter equivalent. The output type is determined by the input:\n`long` converts to `counter_long`, `integer` to `counter_integer`, and `double` to `counter_double`.\nNo values are modified; only the type annotation changes. If the input is already a counter, the function is a no-op. This is useful when a metric field was misclassified as a plain numeric type instead of a counter in the index mapping.\nThis function is also available as the `::counter` cast operator.',
  examples: [
    'TS k8s\n| STATS rate_bytes_in=avg(rate(network.total_bytes_in::counter)) BY time_bucket = bucket(@timestamp,1minute)\n| EVAL rate_bytes_in=ROUND(rate_bytes_in, 6) | KEEP rate_bytes_in, time_bucket\n| SORT rate_bytes_in DESC, time_bucket DESC | LIMIT 10;',
  ],
  params: {
    field: 'Input value. The input can be a single- or multi-valued column or an expression.',
  },
};

export default docs;
